import translate from '../../../i18n'
import {
  creditBatchSourceTypeOptions,
  creditBatchStatusOptions,
} from '../../../pages/credit-batches-container/constant'
import {
  CreditBatchOrderBy,
  ICreditBatchFilterParams,
} from '../../../pages/credit-batches-container/share-type'
import { SearchOutlined } from '@ant-design/icons'
import { Button, DatePicker, Form, InputNumber, Select } from 'antd'
import dayjs from 'dayjs'
import { useEffect } from 'react'

const { RangePicker } = DatePicker

const CreditBatchFilter = ({
  formData,
  onSearch,
}: {
  formData: ICreditBatchFilterParams | undefined
  onSearch: (value: ICreditBatchFilterParams) => void
}) => {
  const [form] = Form.useForm()

  useEffect(() => {
    if (formData) {
      form.setFieldsValue({
        ...formData,
        expiresAtRange:
          formData.expiresAtFrom && formData.expiresAtTo
            ? [dayjs(formData.expiresAtFrom), dayjs(formData.expiresAtTo)]
            : undefined,
      })
    }
  }, [form, formData])

  const onFinish = (values: any) => {
    const { expiresAtRange, id, sourceId, userId, ...other } = values
    onSearch({
      ...other,
      id: id ?? undefined,
      sourceId: sourceId ?? undefined,
      userId: userId ?? undefined,
      expiresAtFrom: expiresAtRange ? dayjs(expiresAtRange[0]).utc().format() : undefined,
      expiresAtTo: expiresAtRange ? dayjs(expiresAtRange[1]).utc().format() : undefined,
    })
  }

  return (
    <Form form={form} layout="inline" style={{ gap: '8px' }} onFinish={onFinish}>
      <Form.Item name="id" label="ID">
        <InputNumber min={1} />
      </Form.Item>
      <Form.Item name="userId" label={translate('creditBatches.userId')}>
        <InputNumber min={1} />
      </Form.Item>
      <Form.Item name="sourceType" label={translate('creditBatches.sourceType')}>
        <Select allowClear options={creditBatchSourceTypeOptions} style={{ width: 240 }} />
      </Form.Item>
      <Form.Item name="sourceId" label={translate('creditBatches.sourceId')}>
        <InputNumber min={1} />
      </Form.Item>
      <Form.Item name="status" label={translate('creditBatches.status')}>
        <Select allowClear options={creditBatchStatusOptions} style={{ width: 140 }} />
      </Form.Item>
      <Form.Item name="expiresAtRange" label={translate('creditBatches.expiresAt')}>
        <RangePicker
          showTime={{
            defaultValue: [dayjs('00:00:00', 'HH:mm:ss'), dayjs('23:59:59', 'HH:mm:ss')],
          }}
        />
      </Form.Item>
      <Form.Item name="orderBy" label={translate('creditBatches.orderBy')}>
        <Select
          style={{ width: 180 }}
          options={[
            {
              value: CreditBatchOrderBy.CREATED_AT,
              label: translate('creditBatches.orderBy.createdAt'),
            },
            {
              value: CreditBatchOrderBy.EXPIRES_AT,
              label: translate('creditBatches.orderBy.expiresAt'),
            },
          ]}
        />
      </Form.Item>
      <Form.Item>
        <Button htmlType="submit" type="primary" icon={<SearchOutlined />}>
          {translate('search')}
        </Button>
      </Form.Item>
    </Form>
  )
}

export default CreditBatchFilter
